import React from 'react';
import OrderBasicComponent from './order-basic-info.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import OrderAddressComponent from './order-address.component';

export const OrderComponent = ({ NetworkType, orderStatus, customers, salesOrders, selectedOrder, onInnerBasicFormChange, back, handleFormSubmit }: any) => {
  const tabItems = [
    {
      id: 1,
      title: 'Order Information',
      component: <OrderBasicComponent

        orderStatus={orderStatus}
        NetworkType={NetworkType}
        customers={customers}
        salesOrders={salesOrders}
        selectedOrder={selectedOrder}
        onInnerBasicFormChange={onInnerBasicFormChange} />,
      isVisible: true,
    },
    {
      id: 2,
      title: 'Address Information',
      component: <OrderAddressComponent

        selectedOrder={selectedOrder} />,
      isVisible: true,
    }
  ]
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end h-20'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}

          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  )
}
export default OrderComponent;